// Comments: English (as you prefer)
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

// Public registry to control later if needed (pause/seek/destroy/etc.)
export const hero7VideoRegistry = []; // [{ section, player, isLoop, trigger }]

// Optional knobs
const NON_LOOP_ONCE = true; // play only the first time section reaches middle
const START_POS = 'top center'; // when top of section hits viewport center

$(document).ready(function () {
    $('.section-hero-type-7').each(function () {
        const $section = $(this);
        const loopFlag = $section.data('loop'); // '0' | '1' | boolean
        const isLoop = loopFlag === 1 || loopFlag === '1' || loopFlag === true;

        const videoEl = $section.find('.js-hero7-video').get(0);
        if (!videoEl) return;

        // Init player
        const player = videojs(videoEl, {
            muted: true,
            preload: 'auto',
            autoplay: isLoop ? 'muted' : false, // non-loop waits for scroll
            playsinline: true,
            controls: false,
            loop: isLoop
        });

        // Helper to attempt play respecting autoplay policies
        const tryPlay = () => {
            player.muted(true);
            player.play().catch((err) => {
                // Retry on user gesture inside the section
                $section.one('click touchstart', () => player.play().catch(() => {}));
            });
        };

        // ScrollTrigger placeholder (assigned later if non-loop)
        let st = null;

        player.ready(function () {
            player.loop(isLoop);

            if (isLoop) {
                // Looping videos play as soon as player is ready
                tryPlay();
            } else {
                // Non-loop videos: start only when section hits middle of viewport
                st = ScrollTrigger.create({
                    trigger: $section.get(0),
                    start: START_POS,
                    // If you want it to fire only once:
                    once: NON_LOOP_ONCE,
                    onEnter: () => {
                        tryPlay();
                    },
                    // Optional: pause/reset when scrolling away (if you disable "once")
                    onLeaveBack: () => {
                        if (!NON_LOOP_ONCE) {
                            try { player.pause(); player.currentTime(0); } catch (e) {}
                        }
                    }
                });
            }

            // Store instance in registry
            hero7VideoRegistry.push({
                section: $section.get(0),
                player,
                isLoop,
                trigger: st
            });
        });
    });
});
